<template>
  <default-form
      ref="form"
      @submit="submitDailyStatus">
    <div class="row row-gap-10 mt-20">
      <div class="col-12">
        <default-select
          required
          :placeholder="$t('dashboard.your_status')"
          :empty_selected_text="$t('inputs.choose_value')"
          :selected_val="get_status"
          :list_outer="get_statuses"
          @change="({id}) => daily_status.status = id"
        />
      </div>
      <div class="col-12">
        <default-select
          required
          :placeholder="$t('dashboard.work_status')"
          :empty_selected_text="$t('dashboard.are_you_working_today')"
          :selected_val="get_work_status"
          :list_outer="yes_no_statuses"
          @change="changeWorkStatus"
        />
      </div>
      <div
        class="col-12">
        <default-select
          v-if="daily_status.working"
          required
          :placeholder="$t('reports.working_place')"
          :empty_selected_text="$t('reports.where_you_working_from')"
          :selected_val="daily_status.working_location"
          :list_outer="Object.values(get_working_locations)"
          @change="(val) => daily_status.working_location = val"
          :blink_select="show_new_el_class"
          key="working_location"
        />
        <default-select
          v-else-if="daily_status.working === 0"
          required
          :placeholder="$t('reports.reason_why_not_working')"
          :empty_selected_text="$t('inputs.choose_value')"
          :selected_val="daily_status.the_reason_if_no"
          :list_outer="get_reason_if_no_list"
          @change="(val) => daily_status.the_reason_if_no = val"
          :blink_select="show_new_el_class"
          key="the_reason_if_no"
        />
      </div>
      <div
          v-if="daily_status.working === 0"
          class="col-12">
        <div class="col-md-12 col-12 mb-10">
          <label class="default-input">
            <span class="default-input__label">
              {{ $t('reports.date_of_work_renewal') }} *
              <span
                  v-if="dateError.status"
                  class="default-input__label-error">
              ({{ $t(dateError.message) }})
              </span>
            </span>

          <div class="default-input__block">
            <input class="default-input__date"
                  type="date"
                   required
                   v-model="daily_status.date_of_work_renewal"
                   @change="changeFateOfWorkRenewal">
          </div>

          </label>
        </div>
      </div>
      <div class="col-6">
        <default-input
          :label="$t('reports.country')"
          v-model="daily_status.country"
        />
      </div>
      <div class="col-6">
        <default-input
          :label="$t('reports.city')"
          v-model="daily_status.city"
        />
      </div>
      <div class="col-12">
        <default-select
          :placeholder="$t('reports.veo_individual')"
          :selected_val="daily_status.veo_individual"
          :empty_selected_text="$t('inputs.choose_value')"
          :list_outer="get_veo_individual"
          @change="(val) => daily_status.veo_individual = val"
        />
      </div>
      <div class="col-6">
        <default-select
          :placeholder="$t('reports.internet')"
          :selected_val="get_internet_status"
          :empty_selected_text="$t('inputs.choose_value')"
          :list_outer="yes_no_statuses"
          @change="({id}) => daily_status.internet = id"
        />
      </div>
      <div class="col-6">
        <default-select
          :placeholder="$t('reports.electricity')"
          :selected_val="get_electricity_status"
          :empty_selected_text="$t('inputs.choose_value')"
          :list_outer="yes_no_statuses"
          @change="({id}) => daily_status.electricity = id"
        />
      </div>
      <div class="col-12">
        <div class="d-flex align-center justify-content-end gap-2">
          <template v-if="google_sheets_reports_has_valid_date">
            <template v-if="distance_to_office !== null">
              <default-button
                button_small
                @click="$refs.locationToOfficePopup.openModal(distance_to_office)"
                type="button">
                <location-icon/>
              </default-button>
              <default-button
                v-if="distance_to_office < office_max_distance && daily_status.working_location !== get_working_locations.site"
                class="btn_info"
                @click="submitWithLocation(get_working_locations.site)"
                type="button">
                Я працюю з офісу
              </default-button>
              <default-button
                v-if="distance_to_office > office_max_distance && daily_status.working_location !== get_working_locations.ho"
                class="btn_info"
                @click="submitWithLocation(get_working_locations.ho)"
                type="button">
                Я працюю з дому
              </default-button>
            </template>
            <default-button
              ref="submit_btn"
              class="ml-auto"
              type="submit">
              {{$t('inputs.submit')}}
            </default-button>
          </template>
          <template v-else>
            <info-block
              class="fw-600">
              Google sheets reports has not valid date
            </info-block>
            <danger-button
              tag="span"
              class="d-inline-block"
              disabled>
              {{$t('inputs.submit')}}
            </danger-button>
          </template>
        </div>
      </div>
    </div>
    <loader v-if="loading"/>
    <location-to-office-popup
      ref="locationToOfficePopup"
    />
  </default-form>
</template>

<script>

import dateMixin from "../../../../mixins/dateMixin";
import {
  BOOL_DATA,
  REASON_IF_NO_DATA,
  VEO_INDIVIDUAL_DATA,
  WORKING_LOCATIONS_DATA,
} from "../../../../helpers/constants";
import {axiosUser} from "../../../../helpers/axios_requests";
import DefaultForm from "../../../small_components/form-parts/DefaultForm.vue";
import DefaultSelect from "../../../small_components/DefaultSelect.vue";
import DefaultInput from "../../../small_components/DefaultInput.vue";
import DefaultButton from "../../../small_components/DefaultButton.vue";
import Loader from "../../../small_components/Loader.vue";
import InfoBlock from "../../../small_components/InfoBlock.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DangerButton from "../../../small_components/DangerButton.vue";
import SlideUpDown from "../../../small_components/SlideUpDown.vue";
import GrayText from "../../../small_components/GrayText.vue";
import LocationIcon from "../../../icons/LocationIcon.vue";
import ExamplePopup from "../../../popups/ExamplePopup.vue";
import LocationToOfficePopup from "../../../popups/LocationToOfficePopup.vue";

const OFFICE_MAX_DISTANCE = 500
const OFFICE_LOCATION = {
  latitude: 49.848776,
  longitude: 24.021075
}

export default {
  name: "UserDailyStatusForm",
  emits: ['reportLoaded', 'SetUserDailyStatus'],
  components: {
    LocationToOfficePopup,
    ExamplePopup,
    LocationIcon,
    GrayText,
    SlideUpDown,
    DangerButton,
    InfoBlock,
    Loader,
    DefaultButton,
    DefaultInput,
    DefaultSelect,
    DefaultForm
  },
  mixins: [dateMixin],
  computed: {
    get_statuses() {
      return BOOL_DATA({yes_text: 'Ok', no_text: 'No'})
    },
    get_status() {
      return this.get_statuses.find(el => el.id === this.daily_status.status)
    },
    yes_no_statuses() {
      return BOOL_DATA({yes_text: 'Yes', no_text: 'No'})
    },
    get_work_status() {
      return this.yes_no_statuses.find(el => el.id === this.daily_status.working)
    },
    get_reason_if_no_list() {
      return REASON_IF_NO_DATA
    },
    get_veo_individual() {
      return VEO_INDIVIDUAL_DATA
    },
    get_working_locations() {
      return WORKING_LOCATIONS_DATA
    },
    get_internet_status() {
      return this.yes_no_statuses.find(el => el.id === this.daily_status.internet)
    },
    get_electricity_status() {
      return this.yes_no_statuses.find(el => el.id === this.daily_status.electricity)
    },
    office_max_distance() {
      return OFFICE_MAX_DISTANCE
    },
  },
  data() {
    return {
      loading: false,
      show_new_el_class: false,
      has_today_report: false,
      google_sheets_reports_has_valid_date: true,
      daily_status: {
        status: null,
        country: '',
        city: '',
        veo_individual: VEO_INDIVIDUAL_DATA[0],
        working: null,
        the_reason_if_no: '',
        date_of_work_renewal: null,
        working_location: '',
        electricity: null,
        internet: null,
      },
      dateError: {
        status: false,
        message: 'reports.date_error_message'
      },
      status_changed_manually: false,
      distance_to_office: null,
    }
  },
  mounted() {
    this.fetchDailyReport()
  },
  methods: {
    ...mapActions([
      'actionPushNotification',
      'actionSetUserDailyStatus'
    ]),
    fetchDailyReport() {
      this.loading = true
      axiosUser.fetchDailyReport()
        .then(({data}) => {
          if (data?.last_report && data?.last_report instanceof Object) {
            this.daily_status.city = data.last_report.city
            this.daily_status.country = data.last_report.country
            this.daily_status.veo_individual = data.last_report.veo_individual
            this.daily_status.working_location = data.last_report.working_location
            this.daily_status.the_reason_if_no = data.last_report.the_reason_if_no
            this.changeWorkStatus({id: data.last_report.working}, false)
            // this.daily_status.working = data.last_report.working
            this.daily_status.status = data.last_report.status
            this.daily_status.internet = data.last_report.internet
            this.daily_status.electricity = data.last_report.electricity
            // prevent adding the expired date of renewal
            if(data.last_report.date_of_work_renewal) {
              let targetDate = new Date(data.last_report.date_of_work_renewal)
              let today = new Date()
              this.daily_status.date_of_work_renewal = today >= targetDate || this.daily_status.working
                ? null
                : data.last_report.date_of_work_renewal
            } else if (this.daily_status.working) {
              this.daily_status.date_of_work_renewal = null
            }
          }
          if (data.google_sheets_reports_has_valid_date) {
            this.google_sheets_reports_has_valid_date = data.google_sheets_reports_has_valid_date
          }
          if (!data.today_report) {
            this.detectPosition()
            return
          }
          this.has_today_report = true
          this.actionSetUserDailyStatus(true);
          Object.entries(data.today_report).forEach(([key, val]) => {
            if (!this.daily_status.hasOwnProperty(key)) return
            this.daily_status[key] = val
          })
        })
        .finally(() => {
          this.loading = false
          this.$emit('reportLoaded', true)
        })
    },
    submitWithLocation(location) {
      this.daily_status.working_location = location
      if (this.$refs.submit_btn?.$el) {
        this.$refs.submit_btn.$el.dispatchEvent(new MouseEvent('click'))
      }
    },
    changeWorkStatus(data, status_changed_manually = true) {
      this.daily_status.working = data.id
      this.show_new_el_class = true
      if (status_changed_manually) {
        this.status_changed_manually = true
      }
      if (data.id) {
        this.daily_status.the_reason_if_no = ''
      } else {
        this.daily_status.working_location = ''
      }
    },
    detectPosition() {
      if (!this.daily_status.working) return
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getPosition, this.getPositionError);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    },
    getPosition(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      // if status set already by user
      // or disable detection if accuracy is more than distance to office (it could be that is using laptop Wi-Fi)
      if (this.status_changed_manually || position.coords.accuracy > this.office_max_distance) return
      this.distance_to_office = this.getDistanceFromLatLonInMeters(latitude, longitude)
    },
    getPositionError(data) {
      console.log(data);
    },
    changeFateOfWorkRenewal(data) {
      this.dateError.status = false
      let selected = new Date(data.target.value);

      if (new Date >= selected) {
        this.dateError.status = true;
      }
    },
    getDistanceFromLatLonInMeters(lat1, lon1) {
      // radius of Earth in meters
      const R = 6371e3;
      const toRad = (value) => (value * Math.PI) / 180;

      const dLat = toRad(OFFICE_LOCATION.latitude - lat1);
      const dLon = toRad(OFFICE_LOCATION.longitude - lon1);

      // formula of an intermediate step in calculation
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(OFFICE_LOCATION.latitude)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return Math.floor(R * c);
    },
    submitDailyStatus() {
      this.loading = true
      if (this.daily_status.date_of_work_renewal?.length > 10) {
        this.daily_status.date_of_work_renewal = null
        return
      }
      axiosUser.createUpdateReport(this.daily_status)
        .then(({data}) => {
          if (data.errors) {
            let message = FORMAT_ERROR_MESSAGE(data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            )
            return;
          }
          this.$root.$emit('SetUserDailyStatus')
          this.has_today_report = true
          this.actionSetUserDailyStatus(true);
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
